module.exports = __webpack_public_path__ + "static/media/11_MEDS-1.9-EQ-14 1.8aca7dd6.svg";